module.exports = "/_next/static/images/sumsub-e1c3e596f99930c9c17e3376ef083896.png";